const Appointments = ({ appointmentDetails, isCounselor }) => {
  // Get today's date and time
  const today = new Date();

  // Function to format a date as MM/DD/YYYY
  const formatDate = (date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Function to extract the date part (MM/DD/YYYY) from an appointment's full date string
  const extractDate = (appointmentDate) => {
    const date = new Date(appointmentDate); // Create Date object from the string
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Filter appointments based on isCounselor flag
  const filteredAppointments = appointmentDetails?.filter(appointment => appointment.IsCounselorApp === isCounselor);

  // Find today's appointment (the one closest to current time)
  const todaysAppointment = filteredAppointments?.find((appointment) => {
    const appointmentDate = new Date(appointment.AppointmentDate);
    const appointmentTime = new Date(`${appointmentDate.toDateString()} ${appointment.AppointmentTime}`).getTime();
    const appointmentDateString = extractDate(appointment.AppointmentDate);

    // Check if the appointment is today
    if (appointmentDateString === formatDate(today)) {
      return true; // Return the first match found (as it's sorted, this is the closest one)
    }
    return false;
  });

  // Find the most recent previous appointment (before today)
  let mostRecentPrevious = null;
  for (let i = 0; i < filteredAppointments?.length; i++) {
    const appointment = filteredAppointments[i];
    const appointmentDate = new Date(appointment.AppointmentDate);
    const todayDate = new Date(today);
    // Set time to midnight to ignore time differences
    todayDate.setHours(0, 0, 0, 0);
    appointmentDate.setHours(0, 0, 0, 0);
    // console.log(i, appointmentDate, todayDate, appointmentDate >= todayDate);
    // Check if the appointment is before today
    if (appointmentDate >= todayDate) {
      mostRecentPrevious = appointment;
    } else if (appointmentDate < todayDate) {
      mostRecentPrevious = appointment;
      break; // Once we hit today's date or a later one, stop searching.
    }
  }

  // console.log(mostRecentPrevious);

  const mostRecentNext = filteredAppointments?.find((appointment) => {
    const appointmentDate = new Date(appointment.AppointmentDate);
    const todayDate = new Date(today);

    // Set time to midnight to ignore time differences
    todayDate.setHours(0, 0, 0, 0);
    appointmentDate.setHours(0, 0, 0, 0);

    // Check if the appointment is after today
    // console.log(appointmentDate > todayDate, appointmentDate, todayDate, appointment);
    if (appointmentDate > todayDate) {
      return true;
    }
    return false;
  });
  return { todaysAppointment, mostRecentPrevious, mostRecentNext, filteredAppointments };
};

export default Appointments;
